package xim.poc.game.configuration.v0

import kotlinx.serialization.Serializable
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import xim.poc.browser.JsonDecoder
import xim.poc.browser.LocalStorage
import xim.poc.game.JobLevel
import xim.poc.game.configuration.MonsterId
import xim.poc.game.configuration.constants.MobSkillId
import xim.poc.game.configuration.constants.mskillNull_0
import xim.poc.game.configuration.v0.interactions.Quantity
import xim.poc.game.configuration.v0.tactics.StatRank
import xim.poc.game.configuration.v0.tactics.TacticsJobConfigs
import xim.poc.game.configuration.v0.tactics.TacticsJobId
import xim.resource.KeyItemId
import xim.util.Periodically
import kotlin.collections.set
import kotlin.time.Duration.Companion.seconds

@Serializable
data class V0MiningExp(
    var level: Int = 1,
    var currentExp: Int = 0,
)

@Serializable
data class EschaZiTahState(
    var visitedPortals: MutableSet<Int> = HashSet(),
)

typealias UnitId = Int
typealias TacticsInstinctId = Int

@Serializable
data class TacticsInstinct(
    val id: TacticsInstinctId,
    val potency: Int,
)

@Serializable
class TacticsUnit(
    val id: UnitId,
    var name: String,
    var currentJob: TacticsJobId,
    var unitLevel: JobLevel = JobLevel(level = 1, exp = 0),
    var highestLevel: Int = unitLevel.level,
    var unitRank: Int = StatRank.D.value,
    var jobLevels: MutableMap<TacticsJobId, JobLevel>,
    var instincts: MutableList<TacticsInstinct> = ArrayList(),
    var inheritance: Array<MobSkillId> = Array(10) { mskillNull_0 },
) {
    init {
        jobLevels.entries.removeAll { TacticsJobConfigs.getNullable(it.key) == null }
    }
}

@Serializable
data class TacticsState(
    var enemyTurnSpeed: Int = 2,
    var skillAnimationSpeed: Int = 2,
    var confirmWait: Boolean = true,
    var units: ArrayList<TacticsUnit> = ArrayList(),
    var challengesCleared: HashSet<Int> = HashSet(),
    var itemsCleared: Int = 0,
)


@Serializable
data class GameV0SaveState(
    var defeatedMonsterCounter: MutableMap<MonsterId, Int> = HashMap(),
    var highestClearedFloor: Int = 0,
    val mining: V0MiningExp = V0MiningExp(),
    val playerSpells: ActorSpells = ActorSpells(),
    var baseCampMusic: Int = 63,
    var keyItems: MutableMap<Int, Int> = HashMap(),
    val eschaZiTahState: EschaZiTahState = EschaZiTahState(),
    val tacticsState: TacticsState = TacticsState()
) {

    fun consumeKeyItem(keyItemId: KeyItemId, quantity: Quantity): Boolean {
        val currentQuantity = keyItems[keyItemId] ?: 0
        return if (currentQuantity < quantity) {
            false
        } else if (currentQuantity == quantity) {
            keyItems.remove(keyItemId)
            true
        } else {
            keyItems[keyItemId] = currentQuantity - quantity
            true
        }
    }

}

object GameV0SaveStateHelper {

    private const val configurationKey = "GameV0"

    private val saveState: GameV0SaveState by lazy { loadState() }
    private val saveRateLimiter = Periodically(5.seconds)

    fun getState(): GameV0SaveState {
        return saveState
    }

    fun autoSave() {
        if (saveRateLimiter.ready()) { writeState() }
    }

    private fun writeState() {
        LocalStorage.writeCustomConfiguration(configurationKey, Json.encodeToString(saveState))
    }

    private fun loadState(): GameV0SaveState {
        val savedState = LocalStorage.readCustomConfiguration(configurationKey)
        return if (savedState == null) { GameV0SaveState() } else { JsonDecoder.decodeFromString(savedState) }
    }

}